import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Menu from "../Menu/Menu";
import "./dashboard.css";
import Swal from 'sweetalert2';
import axios from "axios";
import { toast } from 'react-toastify';
import SaveIcon from '@mui/icons-material/Save';
import SyncIcon from '@mui/icons-material/Sync';
import ReactLoading from 'react-loading';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
} from "@mui/material";

const Dashboard = () => {
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [meusprovedores, setMeusProvedores] = useState([]);
  const [atualizandoMultiplos, setAtualizandoMultiplos] = useState(false);




  const filteredData = data.filter(
    (row) =>
      row.nome.toLowerCase().includes(search.toLowerCase()) ||
      row.tokenlink.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    dadosReposicao()
    dadosProvedores()
  }, []);

  const dadosProvedores = async () => {


    var idusuario = await localStorage.getItem('@idusuario');
    var token = await localStorage.getItem('@token');


    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/listarProvedor.php',
      headers: { 'Content-Type': 'application/json' },
      data: { token: '6d808a40b79c1c6dc0dd1003f58d1c75', token_adm: token, idusuario: idusuario }
    };

    try {
      var dados = await axios(options);
      var resposta = dados.data;
      console.log('meus_provedores', resposta)

      if (resposta.success == false) {
        toast.error(resposta.message);
        return false;
      }

      setMeusProvedores(resposta.data)

    } catch (error) {
      console.log(error)
      toast.error('Encontramos um problema  ao listar os provedores certifique sua conexão e tente mais tarde!');

    }

  }


  const atualizarMultiplos = async () => {

    //verifica se tem ao memos 1 input selecionado

    var getDados = data;

    var objetoSelecionados = [];

    for (var x = 0; x < getDados.length; x++) {

      var id = getDados[x].id_refill;

      var checked = document.getElementById('id_selecionado_' + id).checked;

      if (checked == true) {
        objetoSelecionados.push(getDados[x])
      }

    }

    console.log('objetosSelecionados', objetoSelecionados)

    if (objetoSelecionados.length == 0) {
      toast.warning('Nenhum pedido selecionado!')
    }



    setAtualizandoMultiplos(true)
    for (var x = 0; x < objetoSelecionados.length; x++) {
      await clickAtualizarPedido(objetoSelecionados[x].id_refill, objetoSelecionados[x].idpedido, objetoSelecionados[x].servico, objetoSelecionados[x].link, objetoSelecionados[x].quantidade_inicial, objetoSelecionados[x].quantidade_contratada, true)
      document.getElementById('id_selecionado_' + objetoSelecionados[x].id_refill).checked = false;

    }

    setAtualizandoMultiplos(false)

    ///
    // clickAtualizarPedido(row.id_refill, row.idpedido,row.servico,row.link,row.quantidade_inicial,row.quantidade_contratada,false)

  }

  const dadosReposicao = async () => {
    var logado = await localStorage.getItem('@logado');

    if (logado == null || logado != "S") {
      localStorage.clear()
      navigate('/adminseja')
    }

    var idusuario = await localStorage.getItem('@idusuario');
    var token = await localStorage.getItem('@token');


    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/listarPedidosTotalReposicao.php',
      headers: { 'Content-Type': 'application/json' },
      data: { token: '6d808a40b79c1c6dc0dd1003f58d1c75', token_adm: token, idusuario: idusuario }
    };

    try {
      var dados = await axios(options);
      var resposta = dados.data;
      console.log(resposta)

      if (resposta.success == false) {
        toast.error(resposta.message);
        navigate('/adminseja')
        return false;
      }

      setarDados(resposta.dados)

    } catch (error) {
      console.log(error)
      toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

    }

  }


  const setarDados = async (dados) => {
    setData(dados)
  }

   

  const atualizarStartCountManual = async (id_refill, idpedido, tipo, link, start_count, contratado) => {
    Swal.fire({
      title: "Startcount automático não diponivel, qual startcount atual?",
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
      showCancelButton: true,
      confirmButtonText: "Atualizar",
      showLoaderOnConfirm: true,
      preConfirm: async (id_input) => {

        enviarManualStartCount(id_refill, idpedido, tipo, link, start_count, contratado, id_input)

      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {

    });
  }

  const enviarManualStartCount = async (id_refill, idpedido, tipo, link, start_count, contratado, id_input) => {
    var idusuario = await localStorage.getItem('@idusuario');
    var token = await localStorage.getItem('@token');

    document.getElementById("icone_atualizar_" + id_refill).style.display = "none";
    document.getElementById("icone_atualizar_loader_" + id_refill).style.display = "block";


    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/atualizarStartCountManual.php',
      headers: { 'Content-Type': 'application/json' },
      data: { token: '6d808a40b79c1c6dc0dd1003f58d1c75', token_adm: token, idusuario: idusuario, idpedido: '' + idpedido, servico: '' + tipo, link: link, start_countInicial: "" + start_count, contratado: "" + contratado, id_refill: "" + id_refill, rapidApiManual: '' + id_input }
    };


    try {
      var dados = await axios(options);

      document.getElementById("icone_atualizar_" + id_refill).style.display = "block";
      document.getElementById("icone_atualizar_loader_" + id_refill).style.display = "none";


      var resposta = dados.data;
      console.log(resposta)

      if (resposta.success == false) {
        toast.error(resposta.message);
        return false;
      }


      document.getElementById("quantidade_atual_" + id_refill).innerText = resposta.start_count;


      //calcular Quanto falta

      var getStartCount = "" + resposta.start_count;
      getStartCount = parseInt(getStartCount);

      var start_countInicial = "" + start_count
      start_countInicial = parseInt(start_countInicial)


      var getContratado = "" + contratado;
      getContratado = parseInt(getContratado)

      var temqueficar = start_countInicial + getContratado;


      var falta = temqueficar - getStartCount

      if (falta > 0) {
        falta = "+" + falta
      }

      document.getElementById("quantidade_falta_id_" + id_refill).innerText = falta


      toast.success(resposta.message)


    } catch (error) {
      console.log(error)
      document.getElementById("icone_atualizar_" + id_refill).style.display = "block";
      document.getElementById("icone_atualizar_loader_" + id_refill).style.display = "none";

      toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

    }
  }

  const atualizarStartCount = async (id_refill, idpedido, tipo, link, start_count, contratado, multiplos) => {
    var idusuario = await localStorage.getItem('@idusuario');
    var token = await localStorage.getItem('@token');


    document.getElementById("icone_atualizar_" + id_refill).style.display = "none";
    document.getElementById("icone_atualizar_loader_" + id_refill).style.display = "block";


    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/atualizarStartCount.php',
      headers: { 'Content-Type': 'application/json' },
      data: { token: '6d808a40b79c1c6dc0dd1003f58d1c75', token_adm: token, idusuario: idusuario, idpedido: '' + idpedido, servico: '' + tipo, link: link, start_countInicial: "" + start_count, contratado: "" + contratado, id_refill: "" + id_refill }
    };


    try {
      var dados = await axios(options);

      document.getElementById("icone_atualizar_" + id_refill).style.display = "block";
      document.getElementById("icone_atualizar_loader_" + id_refill).style.display = "none";


      var resposta = dados.data;
      console.log(resposta)

      if (resposta.success == false) {
        toast.error(resposta.message);

        if (multiplos == true) {
          return false
        }

        atualizarStartCountManual(id_refill, idpedido, tipo, link, start_count, contratado)
        return false;
      }


      document.getElementById("quantidade_atual_" + id_refill).innerText = resposta.start_count;


      //calcular Quanto falta

      var getStartCount = "" + resposta.start_count;
      getStartCount = parseInt(getStartCount);

      var start_countInicial = "" + start_count
      start_countInicial = parseInt(start_countInicial)


      var getContratado = "" + contratado;
      getContratado = parseInt(getContratado)

      var temqueficar = start_countInicial + getContratado;


      var falta = temqueficar - getStartCount

      if (falta > 0) {
        falta = "+" + falta
      }

      document.getElementById("quantidade_falta_id_" + id_refill).innerText = falta


      toast.success(resposta.message)


    } catch (error) {
      console.log(error)
      document.getElementById("icone_atualizar_" + id_refill).style.display = "block";
      document.getElementById("icone_atualizar_loader_" + id_refill).style.display = "none";

      toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

      if (multiplos == true) {
        return false
      }
      atualizarStartCountManual(id_refill, idpedido, tipo, link, start_count, contratado)
    }
  }

  const clickSalvar = async (id_refill, idpedido, tipo) => {
    var idusuario = await localStorage.getItem('@idusuario');
    var token = await localStorage.getItem('@token');

    var msg = '';

    if (tipo == 'observacao') {
      msg = document.getElementById("observacao_id" + id_refill).value;
    }

    if (tipo == 'notas') {
      msg = document.getElementById("nota_id_" + id_refill).value;
    }


    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/salvarNotasObs.php',
      headers: { 'Content-Type': 'application/json' },
      data: { token: '6d808a40b79c1c6dc0dd1003f58d1c75', token_adm: token, idusuario: idusuario, id_refill: '' + id_refill, idpedido: '' + idpedido, tipo: tipo, msg: msg }
    };

    try {
      var dados = await axios(options);
      var resposta = dados.data;
      console.log(resposta)

      if (resposta.success == false) {
        toast.error(resposta.message);
        return false;
      }

      toast.success(resposta.message)


    } catch (error) {
      console.log(error)
      toast.error('Encontramos um problema certifique sua conexão e tente mais tarde!');

    }
  }




  function convertDate(dateTime) {

    // Converter a string em um objeto Date
    const dataOriginal = new Date(dateTime);
 
    // Subtrair 3 horas
    const novaData = new Date(dataOriginal.getTime() - 3 * 60 * 60 * 1000);
 
    // Formatar a data no formato DD/MM/YYYY HH:MM:SS
    const [year, month, day] = [
        novaData.getFullYear(),
        String(novaData.getMonth() + 1).padStart(2, "0"), // Mês é zero-indexado
        String(novaData.getDate()).padStart(2, "0")
    ];
    const [hours, minutes, seconds] = [
        String(novaData.getHours()).padStart(2, "0"),
        String(novaData.getMinutes()).padStart(2, "0"),
        String(novaData.getSeconds()).padStart(2, "0")
    ];
 
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
   }

  const Acao = async (id_refill, idpedido) => {

    Swal.fire({
      title: 'Escolha uma ação',
      text: '',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      denyButtonText: 'Opção 2',
      cancelButtonText: 'Cancelar',
      input: 'radio',
      inputOptions: {
        cancelar: 'Cancelar',
        parcial: 'Parcial',
        pendente: 'Pendente'
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Você precisa selecionar uma opção!';
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log(`Você escolheu: ${result.value}`, 'success');

        respostaQualAcao('' + result.value, id_refill, idpedido)

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log('Você cancelou!', 'warning');
      }
    });
  }

  const mudarStatusAPI = async (tipo, id_refill, idpedido) => {
    var status = "" + tipo;

    if (status == "pendente") {
        status = "Pendente";
    }
 
    if (status == "concluido") {
      status = "Concluído";
    }

    if (status == "parcial") {
        status = "Parcial";
    }

    if (status == "cancelar") {
       status = "Cancelado";
    }

    var idusuario = await localStorage.getItem('@idusuario');
    var token = await localStorage.getItem('@token');


    const options = {
      method: 'POST',
      url: 'https://apipedidos.com/painel/atualizarStatus.php',
      headers: { 'Content-Type': 'application/json' },
      data: { token: '6d808a40b79c1c6dc0dd1003f58d1c75', token_adm: token, idusuario: idusuario,status:status,idpedido:idpedido,id_refill:id_refill }
    };

    try {
      var dados = await axios(options);
      var resposta = dados.data;
      console.log('resposta', resposta)

      if (resposta.success == false) {
        toast.error(resposta.message);
        return false;
      }

      toast.success(resposta.message)

      atualizarTabela(""+id_refill)
      

    } catch (error) {
      console.log(error)
      toast.error('Encontramos um problema  ao atualizar o status do pedido');

    }
  }

  const atualizarTabela = async (idremover_refill) => {
    // Copiar os dados originais para evitar alterações inesperadas
    let getDados = [...data];

    // Loop pelos dados para encontrar o item a ser removido
    for (let x = 0; x < getDados.length; x++) {
        // Comparar o id atual com o id a ser removido
        let id = getDados[x].id_refill.toString(); // Garantir que o ID seja string para comparação

        if (idremover_refill === id) {
            getDados.splice(x, 1); // Remover o item pelo índice
            break; // Interromper o loop após encontrar o item
        }
    }

    // Atualizar os dados
    setData(getDados);
};


  const respostaQualAcao = async (tipo, id_refill, idpedido) => {

    if (tipo != "repor") {
      mudarStatusAPI(tipo, id_refill, idpedido)
      return false
    }

    if (tipo == "repor") {

      let optionsHTML = "";
      meusprovedores.forEach((provedor) => {
        optionsHTML += `<option value="${provedor.id}">${provedor.nome}</option>`;
      });

      Swal.fire({
        title: "Confirme o provedor de destino e a quantidade para repor",
        icon: "info",
        html: `

         <div style="display:inline-block">
          <p>O pedido tem o start count de 0, foi comprado 1000, a quantidade atual é 800 e precisa repor 200 </p>

         <div style="display:flex;margin-top:20px">


          <p style="padding-right:10px;">Provedor:</p>
          <select
             id="select_provedor_destino"
            >
            ${optionsHTML}
            </select>
          </div>

           <div style="display:flex;margin-top:20px">
              <p style="padding-right:10px;">Quantidade para repor: </p>
              <input placeholder="X" style="width:120px" id="quantidade_repor"> </input>
            </div>

            </div>
        `,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar reposição',
      }).then(() => {
        var select_provedor_destino = document.getElementById('select_provedor_destino').value
        var quantidade_repor = document.getElementById('quantidade_repor').value


        console.log('select_provedor_destino', select_provedor_destino)
        console.log('quantidade_repor', quantidade_repor)

      });

      return false
    }
  }



  return (
    <>
      <div style={{ flex: 1 }}>
        <div style={{ flex: 1 }}>
          <Menu />
        </div>
      </div>

      <div className="containerMenu">

        <Paper style={{ padding: "20px", margin: "20px auto", backgroundColor: 'white' }}>
          <h2 style={{ textAlign: "center", color: "black",marginBottom:10 }}>Total de Reposição</h2>
          <TextField
            label="Pesquisar"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              marginBottom: "10px",
              borderRadius: "8px",
              background: "#f9f9f9",
            }}
          />
          <TableContainer component={Paper} style={{ borderRadius: "8px" }}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: "#303041" }}>
                  
                  <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                    ID Serviço
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                    Serviço
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                    Valor serviço
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                    Total inseridos
                  </TableCell>
                  <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                    Gasto total
                  </TableCell>
                   
  
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.map((row, index) => (
                  <TableRow
                    key={row.id_refill}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#e8f1f7" : "#ffffff",
                    }}
                  >
                    
                    <TableCell>{row.tokenlink}</TableCell>
  
                    <TableCell>{row.nome}</TableCell>
                    <TableCell>{row.valor_servico}</TableCell>
                    <TableCell>{row.total_quantidade_inserida}</TableCell>
                    <TableCell>
  {row.valor_total
    ? `R$ ${(parseFloat(row.valor_total.replace("R$", "").replace(".", "").replace(",", ".")) / 1000).toFixed(2)}`
    : "N/A"}
</TableCell>


                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </>
  );
};

export default Dashboard;
